/* eslint-disable no-irregular-whitespace */

import coverImage from 'img/vigbo/vigbo-whats-new-cover.png';
import React, { type ReactElement, useMemo } from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';

import styles from './VigboWhatsNew.css';

export interface VigboWhatsNewProps {
    title: ReactElement | string;
    text: string;
    bttnText: string;
    additionalContent: ReactElement;

    onClose?: () => void;
    onClick?: () => void;
    onShow?: () => void;
}

export function VigboWhatsNew({ title, text, bttnText, additionalContent, onClick, onShow, onClose }: VigboWhatsNewProps) {
    const contentNode = useMemo(() => {
        return <div className={styles.contentRoot}>{additionalContent}</div>;
    }, [additionalContent]);

    return (
        <WhatsNewDialog
            buttonTheme="vk"
            dialogSize="average"
            qaId="vigbo-whats-new"
            isRebranding
            imageUrl={coverImage}
            imageAdditionalContent={contentNode}
            onShow={onShow}
            onClick={onClick}
            onClose={onClose}
            title={title}
            text={text}
            textClassName={styles.text}
            primaryButtonText={bttnText}
        />
    );
}
